import { ChangeControlStatus, ReviewStatus } from "@design-controls/types";
import i18n from "../i18n/config";

export const ReviewStatusTable: Record<ReviewStatus, string> = {
  [ReviewStatus.enum.IN_PROGRESS]: i18n.t("statuses.review.draft"),
  [ReviewStatus.enum.SENT_FOR_APPROVAL]: i18n.t("statuses.review.forApproval"),
  [ReviewStatus.enum.APPROVED]: i18n.t("statuses.review.approved"),
  [ReviewStatus.enum.NOT_APPROVED]: i18n.t("statuses.review.declined"),
};

export const ElementReviewStatus: Record<ChangeControlStatus, string> = {
  [ChangeControlStatus.enum.NOT_IN_REVIEW]: i18n.t(
    "statuses.element.notInReview",
  ),
  [ChangeControlStatus.enum.IN_PROGRESS]: i18n.t("statuses.element.inProgress"),
  [ChangeControlStatus.enum.APPROVED]: i18n.t("statuses.element.approved"),
  [ChangeControlStatus.enum.NOT_APPROVED]: i18n.t("statuses.element.declined"),
};
